import React from "react";
import tableIcons from "../../config/tableIcons";
import MaterialTable from "material-table";

const List = ({ columns, rows, getRows, actions, pagination = true, pageSize: initialPageSize = 10, tableRef }) => {
    const isRemote = typeof getRows === "function";
    const rowsPerPageOptions = [10, 30, 50, 100];

    return (
        <MaterialTable
            tableRef={tableRef}
            icons={tableIcons}
            columns={columns}
            actions={actions}
            data={
                isRemote
                    ? (query) =>
                          new Promise((resolve) => {
                              getRows(query.page + 1, query.pageSize, query.search)
                                  .then((resp) => {
                                      if (resp) {
                                          resolve({
                                              data: resp.rows || resp,
                                              page: query.page,
                                              totalCount: resp.total || (resp.rows ? resp.rows.length : resp.length) || 0,
                                          });
                                      } else {
                                          resolve({ data: [], page: 0, totalCount: 0 });
                                      }
                                  })
                                  .catch((err) => {
                                      console.error("Erro ao carregar dados remotos:", err);
                                      resolve({ data: [], page: 0, totalCount: 0 });
                                  });
                          })
                    : rows || []
            }
            options={{
                paging: pagination,
                pageSize: initialPageSize,
                pageSizeOptions: rowsPerPageOptions,
                showTitle: false,
                search: true,
                debounceInterval: 500, // Previne requisições excessivas na busca
            }}
            localization={{
                body: {
                    emptyDataSourceMessage: "Nenhum registro para exibir",
                },
                toolbar: {
                    searchTooltip: "Pesquisar",
                    searchPlaceholder: "Pesquisar",
                },
                header: {
                    actions: "Ações",
                },
                pagination: {
                    labelRowsSelect: "linhas",
                    labelDisplayedRows: "{from}-{to} de {count}",
                    firstTooltip: "Primeira página",
                    previousTooltip: "Página anterior",
                    nextTooltip: "Próxima página",
                    lastTooltip: "Última página",
                },
            }}
            style={{ maxWidth: "90vw", overflow: "auto", minWidth: "80vw" }}
        />
    );
};

export default List;
